import * as Sentry from '@sentry/react'

Sentry.init({
    dsn: __GLOBAL__.VITE_SENTRY_DSN,
    environment: __GLOBAL__.VITE_API_URL.includes('test') ? 'test' : 'production',
    integrations: [
        // Автоматически перехватывает необработанные ошибки и отклонения промисов
        Sentry.globalHandlersIntegration({
            onunhandledrejection: true,
            onerror: true,
        }),
        // Перехватывает ошибки в консоли (опционально, можно убрать)
        Sentry.captureConsoleIntegration({
            levels: ['error'],
        }),
    ],
    tracePropagationTargets: [/^\//],
    tracesSampleRate: 0.2,
    // Включаем автоматическую обработку ошибок
    // beforeSend(event, hint) {
    //      Можно добавить фильтрацию ошибок здесь
    //      Например, игнорировать определенные типы ошибок
    //      return event
    // },
})
